'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _createClassNames = require('./createClassNames');

var _createClassNames2 = _interopRequireDefault(_createClassNames);

var _Highlighter = require('./Highlighter');

var _Highlighter2 = _interopRequireDefault(_Highlighter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cx = (0, _createClassNames2.default)('Snippet');

var Snippet = function Snippet(props) {
  return _react2.default.createElement(_Highlighter2.default, _extends({}, props, { highlightProperty: '_snippetResult', cx: cx }));
};

exports.default = Snippet;


//////////////////
// WEBPACK FOOTER
// ./~/react-instantsearch/src/components/Snippet.js
// module id = 1045
// module chunks = 142807904292071